module.exports = __webpack_public_path__ + "static/ramenyuzu-5dc3eb18ec2beaaac5be93ab1602007f.jpg";